// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    UtensilsCrossed,
    UtilityPole,
    Van,
    Variable,
    Vault,
    VectorPolygon,
    VectorSquare,
    Vegan,
    VenetianMask,
    Venus,
    VenusAndMars,
    Vibrate,
    VibrateOff,
    Video,
    VideoOff,
    Videotape,
    View,
    Virus,
    VirusOff,
    Voicemail,
    Volleyball,
    Volume,
    Volume1,
    Volume2,
    VolumeOff,
    VolumeX,
    Vote,
    Wallet,
    WalletCards,
    WalletMinimal,
    Wallpaper,
    Wand,
    WandSparkles,
    Warehouse,
    WashingMachine,
    Watch,
    WavesArrowDown,
    WavesArrowUp,
    WavesHorizontal,
    WavesLadder,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "utensils-crossed" through "waves-ladder", inclusive. */
const shard: Record<string, LucideIcon> = {
    "utensils-crossed": UtensilsCrossed,
    "utility-pole": UtilityPole,
    van: Van,
    variable: Variable,
    vault: Vault,
    "vector-polygon": VectorPolygon,
    "vector-square": VectorSquare,
    vegan: Vegan,
    "venetian-mask": VenetianMask,
    venus: Venus,
    "venus-and-mars": VenusAndMars,
    vibrate: Vibrate,
    "vibrate-off": VibrateOff,
    video: Video,
    "video-off": VideoOff,
    videotape: Videotape,
    view: View,
    virus: Virus,
    "virus-off": VirusOff,
    voicemail: Voicemail,
    volleyball: Volleyball,
    volume: Volume,
    "volume-1": Volume1,
    "volume-2": Volume2,
    "volume-off": VolumeOff,
    "volume-x": VolumeX,
    vote: Vote,
    wallet: Wallet,
    "wallet-cards": WalletCards,
    "wallet-minimal": WalletMinimal,
    wallpaper: Wallpaper,
    wand: Wand,
    "wand-sparkles": WandSparkles,
    warehouse: Warehouse,
    "washing-machine": WashingMachine,
    watch: Watch,
    "waves-arrow-down": WavesArrowDown,
    "waves-arrow-up": WavesArrowUp,
    "waves-horizontal": WavesHorizontal,
    "waves-ladder": WavesLadder,
};

export default shard;
